<template>
  <el-dialog title="生成声明" :visible.sync="dialogVisible" width="1200px" :close-on-click-modal="false" @close="handleClose">
    <el-form :model="queryParams" label-width="100px" size="small">
      <el-row :gutter="20">
        <el-col :span="8">
          <el-form-item label="使用单位名称">
            <el-input v-model="queryParams.useUntName" placeholder="请输入使用单位名称" clearable />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="小区名称">
            <el-input v-model="queryParams.houseName" placeholder="请输入小区名称" clearable />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="到检年月">
            <el-date-picker
              v-model="queryParams.inspectionMonthList"
              type="month"
              value-format="yyyy-MM"
              placeholder="请选择到检年月"
              style="width: 100%;"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <div style="text-align: center; margin-bottom: 10px;">
        <el-button type="primary" icon="el-icon-search" @click="handleQuery">查询</el-button>
        <el-button type="success" icon="el-icon-download" @click="handleExport">导出</el-button>
      </div>
    </el-form>

    <el-table
      ref="equipmentTable"
      :data="tableData"
      border
      height="420"
      v-loading="loading"
      @selection-change="handleSelectionChange"
      :header-cell-style="{ background: '#d8e8fb', textAlign: 'left', borderColor: '#CCC' }"
    >
      <el-table-column type="selection" width="55" fixed="left"></el-table-column>
      <el-table-column type="index" label="序号" width="60" fixed="left"></el-table-column>
      <el-table-column label="客户名称" prop="compName" min-width="160" show-overflow-tooltip></el-table-column>
      <el-table-column label="到检年月" prop="inspectionMonth" min-width="110" show-overflow-tooltip></el-table-column>
      <el-table-column label="使用单位" prop="useUnitName" min-width="180" show-overflow-tooltip></el-table-column>
      <el-table-column label="设备识别码" prop="oidno" min-width="140" show-overflow-tooltip></el-table-column>
      <el-table-column label="小区名称" prop="houseName" min-width="140" show-overflow-tooltip></el-table-column>
      <el-table-column label="设备代码" prop="eqpStationCod" min-width="140" show-overflow-tooltip></el-table-column>
      <el-table-column label="产品编号" prop="factoryCod" min-width="140" show-overflow-tooltip></el-table-column>
      <el-table-column label="使用登记证编号" prop="eqpUsecertCod" min-width="150" show-overflow-tooltip></el-table-column>
      <el-table-column label="单位内编号" prop="eqpInnerCod" min-width="140" show-overflow-tooltip></el-table-column>
      <el-table-column label="委托编号" prop="entrustNum" min-width="140" show-overflow-tooltip></el-table-column>
    </el-table>

    <div slot="footer" class="dialog-footer">
      <el-button type="primary" :loading="saveLoading" @click="handleSave">保存</el-button>
      <el-button @click="handleClose">退出</el-button>
    </div>
  </el-dialog>
</template>

<script>
import {
  queryInspectionEquipmentList,
  exportInspectionEquipmentList,
  saveConformanceDeclaration
} from '@/api/contract/contract';

export default {
  name: 'GenerateDialog',
  data () {
    return {
      dialogVisible: false,
      loading: false,
      saveLoading: false,
      tableData: [],
      selectedRows: [],
      queryParams: {
        useUntName: '',
        houseName: '',
        inspectionMonthList: []
      }
    };
  },
  methods: {
    openDialog () {
      this.dialogVisible = true;
      this.handleQuery();
    },
    buildParams () {
      const month = this.queryParams.inspectionMonthList;
      return {
        useUntName: this.queryParams.useUntName || '',
        houseName: this.queryParams.houseName || '',
        inspectionMonthList: Array.isArray(month) ? month : (month ? [month] : [])
      };
    },
    handleQuery () {
      this.loading = true;
      queryInspectionEquipmentList(this.buildParams()).then(res => {
        if (res && res.retCode === 'ok') {
          const data = Array.isArray(res.additionalData)
            ? res.additionalData
            : (res.additionalData && Array.isArray(res.additionalData.records) ? res.additionalData.records : []);
          this.tableData = data;
        } else {
          this.tableData = [];
          this.$message.error((res && res.retMsg) || '查询失败');
        }
        this.selectedRows = [];
        this.loading = false;
      }).catch(error => {
        console.error('查询设备列表失败:', error);
        this.loading = false;
        this.tableData = [];
        this.$message.error('查询失败');
      });
    },
    handleExport () {
      exportInspectionEquipmentList(this.buildParams()).then(response => {
        const blob = new Blob([response], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = '生成声明设备列表.xlsx';
        link.style.display = 'none';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
        this.$message.success('导出成功');
      }).catch(error => {
        console.error('导出失败:', error);
        this.$message.error('导出失败');
      });
    },
    handleSelectionChange (rows) {
      this.selectedRows = rows || [];
    },
    handleSave () {
      if (!this.selectedRows.length) {
        this.$message.warning('请先勾选要保存的数据');
        return;
      }
      const firstRow = this.selectedRows[0];
      const sameProject = this.selectedRows.every(row =>
        this.norm(row.useUnitName) === this.norm(firstRow.useUnitName)
        && this.norm(row.houseName) === this.norm(firstRow.houseName)
        && this.norm(row.inspectionMonth) === this.norm(firstRow.inspectionMonth)
      );
      if (!sameProject) {
        this.$message.warning('仅允许保存相同使用单位、到检年月、小区名称的设备，请重新勾选');
        return;
      }
      const equipmentList = this.selectedRows.slice();
      this.saveLoading = true;
      saveConformanceDeclaration({ equipmentList }).then(res => {
        if (res && res.retCode === 'ok') {
          this.$message.success((res && res.retMsg) || '保存成功');
          this.dialogVisible = false;
          this.$emit('refresh');
          return;
        }
        this.$message.error((res && res.retMsg) || '保存失败');
      }).catch(error => {
        console.error('保存失败:', error);
        this.$message.error('保存失败');
      }).finally(() => {
        this.saveLoading = false;
      });
    },
    norm (val) {
      return (val == null ? '' : String(val)).trim();
    },
    handleClose () {
      this.dialogVisible = false;
      this.queryParams = {
        useUntName: '',
        houseName: '',
        inspectionMonthList: []
      };
      this.tableData = [];
      this.selectedRows = [];
    }
  }
};
</script>

<style scoped>
.dialog-footer {
  text-align: right;
}
</style>
